import type { HTMLAttributes, ReactNode } from 'react';

export interface CardProps extends Omit<HTMLAttributes<HTMLDivElement>, 'title'> {
  key?: React.Key;
  title?: string;
  subtitle?: string;
  children?: ReactNode;
  className?: string;
  headerClassName?: string;
  bodyClassName?: string;
}

export function Card({
  title,
  subtitle,
  children,
  className,
  headerClassName,
  bodyClassName,
  ...rest
}: CardProps): JSX.Element {
  const hasHeader = Boolean(title || subtitle);
  const containerClasses = ['panel', className]
    .filter(Boolean)
    .join(' ');

  const headerClasses = ['panel__header', headerClassName].filter(Boolean).join(' ');

  const bodyClasses = ['panel__body', bodyClassName].filter(Boolean).join(' ');

  return (
    <div className={containerClasses} {...rest}>
      {hasHeader ? (
        <div className={headerClasses}>
          {title ? <h3 className="text-base font-semibold text-slate-900">{title}</h3> : null}
          {subtitle ? <p className="text-sm text-slate-600">{subtitle}</p> : null}
        </div>
      ) : null}
      <div className={bodyClasses}>{children}</div>
    </div>
  );
}
